import React from 'react';
import {I18N} from '../globals/config';
import classNames from 'classnames';
import {hot} from 'react-hot-loader/root';
import useCheckboxes from '../hooks/useCheckboxes';
import ErrorBoundary from '../components/ErrorBoundary';
import Items from '../components/checkboxes/Items';

import styles from './checkboxes.pcss';


const Checkboxes = () => {
	const {hasChecked, checkAll, changeList, isSections, updating} = useCheckboxes();

	const tablesClasses = classNames(
		'dashicons',
		styles.icon,
		{
			'dashicons-editor-table': isSections,
			'dashicons-tablet': ! isSections,
		} );

	const checkAllClasses = classNames(
		'dashicons',
		styles.icon,
		{
			'dashicons-yes': ! hasChecked,
			'dashicons-no-alt': hasChecked,
		} );

	return (
		<ErrorBoundary>
			<div className={'go-live-section'}>
				<button
					id="go-live-update-urls-pro/containers/checkbox/change-list"
					className={`button-primary ${styles.button}`}
					onClick={ev => {
						ev.preventDefault();
						changeList( ! isSections );
					}}>
					<span className={tablesClasses} />
					{isSections ? I18N.use_tables : I18N.use_sections}
				</button>
				<p className={styles.only}>
					<strong>
						{isSections ? I18N.only_sections : I18N.only_tables}
					</strong>
				</p>
				<Items />
				<button
					id="go-live-update-urls/containers/checkboxes/check-all"
					className={`button-secondary ${styles.button}`}
					disabled={updating}
					onClick={ev => {
						ev.preventDefault();
						checkAll();
					}}>
					<span className={checkAllClasses} />
					{hasChecked ? I18N.uncheck_all : I18N.check_all}
				</button>
			</div>
		</ErrorBoundary>
	);
};

export default hot( Checkboxes );

